import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {DxNavigationTreeNode} from "../../../../../domain/navigator/dx-navigation-tree-node";
import {DxAppEvent} from "../../../../../../dx-core/domain/events/dx-app-event";


@Component({
  selector: 'dx-side-dropdown-list',
  templateUrl: './dx-side-dropdown-list.component.html',
  styleUrls: ['./dx-side-dropdown-list.component.css']
})
export class DxSideDropdownListComponent implements OnInit, OnDestroy {
  /** Узел первого уровня навигационного меню, являющийся корнем ветки для данного пункта */
  private _menuNode: DxNavigationTreeNode;
  /** Узлы второго уровня бокового навигационного дерева. */
  private _items: DxNavigationTreeNode[];
  /** Текущий активный элемент */
  private _activeItem: DxNavigationTreeNode;
  /** Внешняя установка начального выдедления при открытии списка. */
  private _selection: DxNavigationTreeNode;

  /** Событие выбрасывается при клике по элементу списка */
  @Output()
  public itemClick: EventEmitter<DxAppEvent> = new EventEmitter();

  /** @constructor */
  constructor() {}

  ngOnInit(): void {
    this._items = this._menuNode.children;
    if (this._selection) this.selectItem(this._selection);
  }

  ngOnDestroy(): void { }

  @Input()
  set menuNode(value: DxNavigationTreeNode) {
    this._menuNode = value;
  }

  @Input()
  set selection(value: DxNavigationTreeNode) {
    this._selection = value;
  }

  get id(): number {
    return this._menuNode.id;
  }

  get items(): DxNavigationTreeNode[] {
    return this._items;
  }


  public onListItemClick(item: DxNavigationTreeNode): void {
    if(!(this._activeItem && this._activeItem.id === item.id)) {
      this._activeItem = item;
      this.itemClick.emit(new DxAppEvent('dx-side-dropdown-list', item));
    }
  }


  public selectItem(node: DxNavigationTreeNode): boolean {
    if(this._items.find(item => item.id === node.id)) {
      this._activeItem = node;
      return true;
    }
    return false;
  }


  public isActiveItem(item: DxNavigationTreeNode): boolean {
    if(this._activeItem) {
      return  this._activeItem.id === item.id;
    }
    return  false;
  }
}
